module.exports = __webpack_public_path__ + "img/character-grandpa-happy.2950219e.svg";